@if (isLoading) {
    <div class="fancy-loader"></div>
} @else {
    <app-linkable
        typename="audits"
        displayValueProp="name"
        idValueProp="id"
        [linked]="linked"
        [unlinked]="unlinked"
        [orderByValueProperty]="true"
        [disabled]="disabled"
        [hideActions]="true"
        [hideFilter]="true"
        [allowAddNew]="false"
        [rendererConfig]="rendererConfig"
        (onOpenClicked)="openItem($event)"
        (onReloadClicked)="reload()"
        (linkedChange)="linkedItemsChanged($event)"
        [allowEditItem]="allowEditItem"
        [allowBatchEdit]="allowBatchEdit"
        [allowOpenItem]="true"
        [allowReload]="true"
    >
    </app-linkable>
}
